"use client";

import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import { Suspense, useState } from "react";

import { criarClienteBrowser } from "@/core/supabase/client";
import { sanitizarNext } from "@/core/seguranca";
import { BotaoGoogle } from "../_components/BotaoGoogle";
import { mensagemDeErro } from "../_lib/erros";

function FormEntrar() {
  const router = useRouter();
  const params = useSearchParams();
  const next = sanitizarNext(params.get("next")); // evita open redirect (#9)

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(false);

  async function entrar(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setCarregando(true);
    const supabase = criarClienteBrowser();
    const { error } = await supabase.auth.signInWithPassword({ email, password: senha });
    if (error) {
      setErro(mensagemDeErro(error));
      setCarregando(false);
      return;
    }
    router.push(next);
    router.refresh();
  }

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-center font-[family-name:var(--font-barlow-titulos)] text-xl font-bold uppercase tracking-wider">
        Entrar
      </h1>

      <form onSubmit={entrar} className="flex flex-col gap-3">
        <input
          type="email"
          required
          autoComplete="email"
          placeholder="Seu e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-[10px] border border-[#2a2a2a] bg-[#1f1f1f] px-4 py-3 text-sm placeholder-[#8a8a8a] outline-none focus:border-[#555]"
        />
        <input
          type="password"
          required
          autoComplete="current-password"
          placeholder="Sua senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          className="w-full rounded-[10px] border border-[#2a2a2a] bg-[#1f1f1f] px-4 py-3 text-sm placeholder-[#8a8a8a] outline-none focus:border-[#555]"
        />

        {erro && <p className="text-sm text-[#ff5d5d]">{erro}</p>}

        <button
          type="submit"
          disabled={carregando}
          className="w-full rounded-[10px] bg-white px-4 py-3 text-sm font-semibold text-black transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          {carregando ? "Entrando..." : "Entrar"}
        </button>
      </form>

      <div className="flex items-center gap-3 text-xs text-[#8a8a8a]">
        <span className="h-px flex-1 bg-[#2a2a2a]" />
        ou
        <span className="h-px flex-1 bg-[#2a2a2a]" />
      </div>

      <BotaoGoogle next={next} />

      <div className="mt-2 flex flex-col gap-2 text-center text-sm">
        <Link href="/recuperar-senha" className="text-[#8a8a8a] hover:text-[#ededed]">
          Esqueci minha senha
        </Link>
        <p className="text-[#8a8a8a]">
          Ainda não tem conta?{" "}
          <Link href="/registrar" className="font-medium text-[#ededed] underline underline-offset-4">
            Criar conta
          </Link>
        </p>
      </div>
    </div>
  );
}

export default function PaginaEntrar() {
  return (
    <Suspense>
      <FormEntrar />
    </Suspense>
  );
}
